export default __webpack_public_path__ + "static/media/polygon-web-1.3f613e2a.svg";